import { DateTimeExtension } from '80.quickConnect.Core/formatting/DateTimeExtension';

export default function mapAllFieldTypeValuesToTime(value: unknown): Date | null | undefined {
  if (value === null || value === '') return null;

  if (!(typeof value === 'string') && !(value instanceof Date)) return undefined;

  return DateTimeExtension.parseToTime1970(value) ?? undefined;
}
